import React, { useState } from 'react';
import { Form, Table, Button, Modal } from 'react-bootstrap';
import { formatterPeso, mFormat } from 'src/utils/utils';
import ActionIcon from 'src/components/general/ActionIcon';
import { faSave, faTimes, faSearch, faEdit } from '@fortawesome/free-solid-svg-icons';
import ModalCertificadoServicios from 'src/components/pages/OrderPay/modal/ModalCertificadoServicios';
import { FormProvider } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CertificadoServiciosTable = (props) => {

	const [showPayOrderDetailModal, setShowPayOrderDetailModal] = useState(false);
	const [data, setData] = useState('');
	const [index, setIndex] = useState('');
	const [showEditModal, setShowEditModal] = useState(false);
	const { tipo, checkKeyDown, hookFormMethodsModal, hookFormMethodsModal:{handleSubmit} = {}, stopPropagate,
			onSubmitForm, ticketObj, handleOrganismOnChange, codeOrganism,organismList
		  } = props?._hookFormMethodsModal || {};

    const onClickRemove = index => {
		props.setReceipts(props.receipts?.filter((item, i) => i !== index));
    };

    const _onSubmitForm = (arg)=>{
    	onSubmitForm(arg, index);
    	setShowEditModal(false);
    }

	const handleModal = (item) => {
		setData(item);
		setShowPayOrderDetailModal(true);
    };

    const editarRecibo = (item, index) =>{
    	ticketObj?.setTicketData(item.tickets);
    	handleOrganismOnChange(item.codeOrganism);
		setData(item);
		setIndex(index);
    	setShowEditModal(true);
    }

    return <>
			<Table striped hover size='sm' responsive style={{ borderRadius: '6px', overflow: 'hidden' }}>
				<thead className='text-white-color'>
					<tr>
						<th className='text-center align-middle tipeTableFormat tbTipo'>Fecha</th>
						<th className='text-center align-middle' width="40%">Factura</th>
						<th className='text-center align-middle' width="20%">Importe</th>
						<th className='text-center align-middle' width='10%'>Inicio</th>
						<th className='text-center align-middle' width='10%'>Fin</th>
						<th className='text-center align-middle th-minwidth'>Acciones</th>
					</tr>
				</thead>
				<tbody className='text-black-color'>{
					props.receipts?.map((item, i) =>
						<tr key={i}>
							<td className='text-center align-middle tipeTableFormat tbTipo'>
								{mFormat(item?.receiptDate)}
							</td>
							<td className='text-center align-middle tipeTableFormat tbTipo'>
								{item?.tickets?.map((v) => v.ticket).flat()?.join(', ')}
							</td>
							<td className='text-right align-middle tipeTableFormat tbTipo'>
								{ formatterPeso.format(item.tickets.map((v) => v.amount)
									.flat()?.reduce((prev, next) => Number(prev) + Number(next)))
								}
							</td>
							<td className='text-center align-middle tipeTableFormat tbTipo'>
								{mFormat(item?.periodStart)}
							</td>
							<td className='text-center align-middle actionTableFormat tbAction'>
								{mFormat(item?.periodEnd)}
							</td>
							<td className='text-center align-middle px-2 m-0 table-responsive btn-group'>
								<ActionIcon size='lg' toolTipText='Detalle' icon={faSearch}  onClick={() => handleModal(item)} />
								{handleSubmit && <ActionIcon size='lg' toolTipText='Editar' icon={faEdit}  onClick={() => editarRecibo(item, i)} />}
								<ActionIcon size='lg' hidden={props?.orderPayDetailData} toolTipText='Remover' icon={faTimes} className='text-danger' onClick={() => onClickRemove(i)} />
							</td>
						</tr>
					)}
				</tbody>
			</Table>
			<Modal show={showPayOrderDetailModal} onHide={() => setShowPayOrderDetailModal(false)} dialogClassName="modal-xl">
				<Modal.Header closeButton>
					<Modal.Title>Certificación de Servicio</Modal.Title>
				</Modal.Header>

				<Modal.Body className='mt-4 text-black-color'>
					<ModalCertificadoServicios
						organismList={organismList}
						data={data}
						onlyRead
					/>
						<div className='d-flex justify-content-end mt-4 mb-3'>
							<Button type='button' variant='danger' size='lg' onClick={() => setShowPayOrderDetailModal(false)}>
								Cerrar
							</Button>
						</div>
				</Modal.Body>
			</Modal>

			{handleSubmit && 
				<Modal show={showEditModal} onHide={() => setShowEditModal(false)} dialogClassName="modal-xl">
					<Modal.Header closeButton>
						<Modal.Title>Edición Certificación de Servicio</Modal.Title>
					</Modal.Header>
	
					<Modal.Body className='mt-4 text-black-color'>
						<FormProvider {...hookFormMethodsModal } >
							<Form className='mt-4 text-black-color' onKeyDown={(e) => checkKeyDown(e)} onSubmit={stopPropagate(handleSubmit(_onSubmitForm))} >
								<ModalCertificadoServicios
									organismList={organismList}
									data={data}
									ticketObj={ticketObj}
									codeOrganism={codeOrganism}
									handleOrganismOnChange={handleOrganismOnChange}
									tipo={tipo}
								/>
			                    <div className='d-flex justify-content-around mt-4 mb-3'>
			                        <Button type='button' variant='danger' size='lg' onClick={()=>setShowEditModal(false)}>
			                            Cancelar
			                        </Button>
			                        <Button
			                            type='submit'
			                            variant='success'
			                            size='lg'>
			                            Guardar
			                            <FontAwesomeIcon icon={faSave} className='ml-2 text-white-color ' />
			                        </Button>
								</div>
							</Form>	            
						</FormProvider>
					</Modal.Body>
				</Modal>}
    </>
};

export default CertificadoServiciosTable;